import { defineComponent as _defineComponent } from 'vue'
import moment from 'moment'

import JobHistoryDaySection from './JobHistoryDaySection.vue'
import TimelineCommentBox from '@/components/common/timeline/TimelineCommentBox.vue'
import JobHistory from '@/models/job-history'
import JobComment from '@/models/job-comment'
import { createNamespacedHelpers } from 'vuex-composition-helpers'
import { useActivityLog } from './composables/useActivityLog'

interface Props {
  jobId: string
  jobHubId: string
  startTime?: moment.Moment | null
  endTime?: moment.Moment | null
  loadHistoryError?: boolean
  history?: JobHistory[] | null
  comments?: JobComment[] | null
}

export default /*#__PURE__*/_defineComponent({
  __name: 'JobActivityLog',
  props: {
    jobId: null,
    jobHubId: null,
    startTime: { default: null },
    endTime: { default: null },
    loadHistoryError: { type: Boolean, default: false },
    history: { default: null },
    comments: { default: null }
  },
  emits: ["submit-comment"],
  setup(__props: any, { emit }: { emit: ({ (e: 'submit-comment', value: string | null) }), expose: any, slots: any, attrs: any }) {

const props: Props = __props as { jobId: string, jobHubId: string, startTime: moment.Moment | null, endTime: moment.Moment | null, loadHistoryError: boolean, history: JobHistory[] | null, comments: JobComment[] | null }



const { isJobSaving } = createNamespacedHelpers('jobs').useGetters([
  'getSaving',
])

const { jobCommentsEnabled } = createNamespacedHelpers(
  'featureFlags'
).useGetters(['jobCommentsEnabled'])

const { jobHistory } = useActivityLog(props)


const handleSubmitComment = (comment: string) => {
  emit('submit-comment', comment)
}

return { __sfc: true,props, isJobSaving, jobCommentsEnabled, jobHistory, emit, handleSubmitComment, JobHistoryDaySection, TimelineCommentBox }
}

})